module.exports = __webpack_public_path__ + "img/entrance_kr.9148adf9.png";